// x-filter-frontpage-rows.js

/*
Custom filter for frontpage rows
Example use on circle-u:
https://www.circle-u.eu/resources/seed-funded-projects/index.html
*/

export default function xFilterFrontpageRows() {

  const listingFilterCustom = document.querySelector(".vrtx-listing-filter-custom");

  if (listingFilterCustom) {
    const filterLinks = document.querySelectorAll(".vrtx-listing-filter-parameter a");
    const checkAllFiltersLink = document.getElementById("checkAll");
    const filteredBoxes = document.querySelectorAll("div[class*='checked-']");

    // Find filtered rows based on containing filtered boxes
    filteredBoxes.forEach(box => {
      box.closest(".grid-container").classList.add("filtered-row");
    });
    const filteredRows = document.querySelectorAll(".grid-container.filtered-row");

    // Create and include counter for filtered rows
    const counter = document.createElement("span");
    counter.className = "row-counter";
    counter.setAttribute("role", "status");
    listingFilterCustom.after(counter);

    // Update counter
    function updateCounter() {
      const activeRows = document.querySelectorAll(".filtered-row:not(.inactive-row)").length;
      let counterText = "Antall treff: "
      if (document.documentElement.lang === "en") {
        counterText = "Number of hits: "
      }
      counter.textContent = counterText + activeRows;
    }
    updateCounter();

    // Filterlinks click function
    function filterClick(event) {
      event.preventDefault(); // Prevent the default link behavior (e.g., page reload)
      const link = event.currentTarget;

      // If clicked checkAll filter-link..
      if (link.id === "checkAll") {

        // Clear all selected filter-links
        link.closest("ul").querySelectorAll("a").forEach(link => {
          link.setAttribute("aria-checked", "false");
        });

        // Select current link
        link.setAttribute("aria-checked", "true");

        // Clear all selected- classes from boxes
        filteredBoxes.forEach(box => {
          Array.from(box.classList)
            .filter(cls => cls.startsWith('selected-'))
            .forEach(cls => box.classList.remove(cls));
        });

        // Clear all inactive classes from rows
        filteredRows.forEach(row => {
          row.classList.remove("inactive-row");
        });
      }

      // If clicked a filter-link except checkAll
      else {
        checkAllFiltersLink.setAttribute("aria-checked", "false");

        // Get matching boxes
        const matchingBoxes = document.querySelectorAll(`.checked-${link.id}`);

        if (link.getAttribute("aria-checked") === "false") {
          link.setAttribute("aria-checked", "true");
          // Select matching boxes
          matchingBoxes.forEach(matchingBox => {
            matchingBox.classList.add("selected-" + link.id);
          });
        }
        else {
          link.setAttribute("aria-checked", "false");
          // Deselect matching boxes
          matchingBoxes.forEach(matchingBox => {
            matchingBox.classList.remove("selected-" + link.id);
          });
        }

        // Filter out rows that don't contain any selected boxes
        filteredRows.forEach(row => {
          if (row.querySelector("[class*=selected-]") === null) {
            row.classList.add("inactive-row");
          }
          else {
            row.classList.remove("inactive-row");
          }
        });

        // If all rows inactive, run click event on checkAll filter link
        const inactiveRows = document.querySelectorAll(".inactive-row");
        if (inactiveRows.length === filteredRows.length) {
          checkAllFiltersLink.click();
        }
      }
      updateCounter();
    }

    // Filterlinks
    filterLinks.forEach(link => {
      link.setAttribute("role", "checkbox");
      link.setAttribute("aria-checked", "false");

      // Filterlinks click event
      link.addEventListener("click", filterClick);

      // Enable click event for spacebar
      link.addEventListener("keydown", keyEvent => {
        if (keyEvent.code === "Space") {
          keyEvent.preventDefault(); // Prevent default scrolling with spacebar
          link.click();
        }
      })
    });

    // Set initial aria-checked for checkAllFiltersLink
    checkAllFiltersLink.setAttribute("aria-checked", "true");
  }
}